var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App",attrs:{"id":"app"}},[_c('img',{staticClass:"App-logo",attrs:{"src":require("images/logo-white.svg?file")}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }